// components/products/ProductSkeletonRow.jsx
import { TableRow, TableCell, Stack, Skeleton } from '@mui/material';

export default function ProductSkeletonRow() {
    return (
        <TableRow>
            <TableCell>
                <Stack direction="row" spacing={2} alignItems="center">
                    <Skeleton variant="rounded" width={50} height={50} />
                    <Skeleton variant="text" width={120} />
                </Stack>
            </TableCell>

            <TableCell>
                <Skeleton variant="text" width={100} />
            </TableCell>
            <TableCell>
                <Skeleton variant="text" width={70} />
            </TableCell>

            <TableCell>
                <Skeleton variant="rounded" width={70} height={30} />
            </TableCell>

            <TableCell align="right">
                <Skeleton variant="rounded" width={70} height={30} />
            </TableCell>
        </TableRow>
    );
}
